import React, { Component } from 'react'
import { Col, Row } from 'antd'
import moment from 'moment-business-days'
import { dateFormat, simpleDateTimeFormat } from '../../lib/DateFormat'

export default class InfoOrders extends Component {
  render() {
    const { t, order, isQuotation } = this.props
    const title = isQuotation ? t('Quotation') : t('Order')
    return (
      <Col>
        <Row>
          <Col>
            <h4 className='content-title'>{title}</h4>
          </Col>
        </Row>
        {!isQuotation && (
          <Row>
            <Col span={6}>
              <span>{t('SAP Code')}</span>
            </Col>
            <Col span={15}>
              <b>{order.numeroPedidoSAP}</b>
            </Col>
          </Row>
        )}
        <Row>
          <Col span={6}>
            <span>{t('Status')}</span>
          </Col>
          <Col span={15}>
            <b>{t(`STATUS_${order.status.toUpperCase()}`)}</b>
          </Col>
        </Row>
        {isQuotation && (
          <Row>
            <Col span={6}>
              <span>{t('Valid until')}</span>
            </Col>
            <Col span={15}>
              <b>{moment(order.fecha_validez).format(dateFormat)}</b>
            </Col>
          </Row>
        )}
        <Row>
          <Col span={6}>
            <span>{t('Create date')}</span>
          </Col>
          <Col span={15}>
            <b>{moment(order.createdAt).format(simpleDateTimeFormat)}</b>
          </Col>
        </Row>
        <Row>
          <Col span={6}>
            <span>{t('Update date')}</span>
          </Col>
          <Col span={15}>
            <b>{moment(order.updatedAt).format(simpleDateTimeFormat)}</b>
          </Col>
        </Row>
        <Row>
          <Col span={6}>
            <span>{t('Remarks')}</span>
          </Col>
          <Col span={15}>
            <b>{order.observaciones}</b>
          </Col>
        </Row>
      </Col>
    )
  }
}
